import { useQuery } from '@tanstack/react-query';
import { reservationApi } from '@/api/reservations';
import { formatDateForApi } from '@/utils/date';

/**
 * React Query hook to fetch available time slots
 * Automatically refetches when date, people count, or children count changes
 */
export function useTimeslots(
  storeDomain: string | null,
  date: Date | null,
  people: number,
  children: number = 0
) {
  return useQuery({
    queryKey: ['timeslots', storeDomain, date, people, children],
    queryFn: () => {
      if (!storeDomain || !date) {
        throw new Error('Store domain and date are required');
      }
      return reservationApi.getTimeslots(storeDomain, {
        date: formatDateForApi(date),
        adults: people,
        children: children,
      });
    },
    enabled: !!storeDomain && !!date && people > 0, // Only fetch when all required data is available
    staleTime: 60 * 1000, // Cache for 1 minute (timeslots change frequently)
    retry: 1, // Only retry once for timeslots
  });
}
